import Paragraph from '@/shared/Paragraph/ui/Paragraph';
import Link from 'next/link';
import { memo } from 'react';
import { CommonPageType } from '../../../domain/CommonPage.domain';
import * as S from './Description.styles';

type DescriptionProps = {
    type: CommonPageType;
    title: string;
};

const DescriptionContainer = ({ type }: DescriptionProps) => {
    return (
        <Paragraph id="paragraph-text">
            <>
                {type === 'blog' && (
                    <>
                        The{' '}
                        <Link href="/blog/" passHref>
                            <S.StyledLink>TripShock blog</S.StyledLink>
                        </Link>{' '}
                        delivers in-demand travel info directly to your electronic devices. From
                        vacation guides to money-saving coupons and travel tips, the TripShock blog
                        has something for everyone! LEARN, DISCOVER, AND HAVE SOME FUN with travel
                        articles in these popular destinations!
                    </>
                )}
                {type === 'partners' && (
                    <>
                        Our activity partners offer the hottest experiences combined with a proven
                        track record of service and reliability. Discover which operators are
                        currently partnered with TripShock, view their tours, and book online on{' '}
                        <Link href="/" passHref>
                            <S.StyledLink>Tripshock.com.</S.StyledLink>
                        </Link>
                    </>
                )}
            </>
        </Paragraph>
    );
};

export const Description = memo(DescriptionContainer);
